import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[shoelaceReadonly]'
})
export class ShoelaceReadonlyDirective implements OnInit {

  @Input('shoelaceReadonly')readonly: boolean | undefined = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    if (this.readonly) {
      this.renderer.setAttribute(this.el.nativeElement, 'readonly', '');
      this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'none');
    }
  }
}
